<div class="min-h-screen flex flex-col">
  <app-auth-navbar></app-auth-navbar>

  <main class="w-full flex-1 pb-[90px] md:pb-[90px] lg:pb-0">
    <router-outlet></router-outlet>
  </main>

  <app-public-footer></app-public-footer>
</div>
